module.exports = __webpack_public_path__ + "img/GH-kyujin-top-042.ec0f2913.webp";